<template>
  <div class="leaderBrdpop">
    <div
      :class="
        weekMonthLeaderboard === 'month'
          ? 'leadBoardContent monthlyleaderboard'
          : 'leadBoardContent weeklyleaderboard'
      "
    >
      <span class="goBackicon">
        <i class="material-icons" @click="handleBack">close</i>
      </span>
      <div class="leadTophead">
        <div class="headImgbox" v-if="weekMonthLeaderboard === 'month'">
          <img src="../../src/assets/images/monthly-logo.png" />
        </div>
        <div class="headImgbox" v-if="weekMonthLeaderboard === 'week'">
          <img src="../../src/assets/images/weekly-logo.png" />
        </div>
        <!-- <div class="winTitle">WIN ₹10000</div> -->
      </div>
      <!-- <h2>लीडर बने और कैश कमाए</h2> -->
      <div class="leadInner">
        <div class="leadTitlehead">
          <div class="title title_1">{{ $t('Position') }}</div>
          <div class="title title_2">{{ $t('NameName') }}</div>
          <div class="title title_3">{{ $t('DurationTime') }}</div>
          <div class="title title_4">{{ $t('Score') }}</div>
        </div>
        <leaderBoardViewport
          :leaderBoardViewportList="leaderBoardViewportList"
          :xAuthIdUser="XAuthID"
          :page="page"
          :DD="DD"
          :MM="MM"
          :weekMonthLeaderboard="weekMonthLeaderboard"
        />
        <LeaderBoardSelectedList :topUser="userData" />
      </div>
    </div>
  </div>
</template>
<script>
import leaderBoardViewport from './leaderBoardViewport'
import LeaderBoardBanner from './LeaderBoardBanner'
import LeaderBoardSelectedList from './LeaderBoardSelectedList'
import { compare } from '../utils/helper'
import { BASE_API_URL, LOCAL_URL } from '../utils/constant'
import * as Cookies from 'js-cookie'
import InfiniteLoading from 'vue-infinite-loading'
import Vue from 'vue'
Vue.use(InfiniteLoading)

export default {
  name: 'leaderBoard15aug',
  components: {
    leaderBoardViewport,
    LeaderBoardBanner,
    LeaderBoardSelectedList,
    InfiniteLoading
  },
  props: [
    'XAuthID',
    'weekMonthLeaderboard',
    'weekMonthly',
    'leaderBoardViewportList'
  ],
  data() {
    return {
      DD: new Date().getDate(),
      MM: new Date().getUTCMonth() + 1,
      userData: {},
      page: 1
    }
  },
  methods: {
    handleBack() {
      document.querySelector('body').classList.remove('leadBodypop')
      // window.location.href = 'http://localhost:8080/#/'
    }
  },
  watch: {
    weekMonthLeaderboard: function(newVal, oldval) {
      console.log('=-=-newVal=-=', newVal)
    }
  },
  mounted() {
    console.log('=-=this.weekMonthLeaderboard-=', this.weekMonthLeaderboard)
  }
}
</script>
<style scoped></style>
